export default __webpack_public_path__ + "static/media/icon-clock-orange.b4c0764d.svg";